export enum Colors{
    Primary = "rgb(0,0,145)",
    Result = "rgb(65,125,196)",
    Result2 = "rgb(102,103,61)",
    Up = "rgb(0,169,95)",
    UpDarker = "rgb(41,114,84)",
    Neutral = "rgba(0,0,0,0.85)",
    Down = "rgb(206,97,74)",
    DownDarker = "rgb(169,70,69)"
}